<template>
  <div class="animated fadeIn">
    <b-card-group columns class="card-columns">
      <b-card header="button">
        <div>
          <el-button type="info">test</el-button>
          <el-button type="success">test</el-button>
          <el-button type="danger">test</el-button>
          <el-button type="primary">test</el-button>
        </div>
        <div class="mt-1">
          <el-button type="info" plain>test</el-button>
          <el-button type="success" plain>test</el-button>
          <el-button type="danger" plain>test</el-button>
          <el-button type="primary" plain>test</el-button>
        </div>
      </b-card>
      <b-card header="a Elements">
        <a>this is a test message for color test</a>
      </b-card>
    </b-card-group>
  </div>
</template>
<script>
export default {
  name: "colorTest",
  components: {},
};
</script>
